import { useEffect, useState } from "react";
import { navLinks, siteMeta } from "@/mocks/guage";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("top");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
      let current = "top";
      navLinks.forEach((link) => {
        const el = document.getElementById(link.id);
        if (el && el.getBoundingClientRect().top <= 140) {
          current = link.id;
        }
      });
      setActive(current);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleJump = (id: string) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6 h-16 md:h-20 flex items-center justify-between">
        <button
          type="button"
          onClick={() => handleJump("top")}
          className="flex items-center gap-2 md:gap-3 cursor-pointer"
        >
          <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-water-flash-fill text-lg md:text-xl"></i>
          </span>
          <span className="flex flex-col items-start leading-none">
            <span
              className={`font-heading text-lg md:text-2xl tracking-wide ${
                scrolled ? "text-foreground-950" : "text-background-50"
              }`}
            >
              {siteMeta.brand}
            </span>
            <span
              className={`text-[10px] md:text-xs mt-0.5 ${
                scrolled ? "text-foreground-500" : "text-background-50/80"
              }`}
            >
              {siteMeta.slogan}
            </span>
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <button
              key={link.id}
              type="button"
              onClick={() => handleJump(link.id)}
              className={`px-3 py-2 rounded-md text-sm whitespace-nowrap transition-colors cursor-pointer ${
                active === link.id
                  ? scrolled
                    ? "bg-primary-100 text-primary-700"
                    : "bg-background-50/20 text-background-50"
                  : scrolled
                    ? "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                    : "text-background-50/85 hover:text-background-50 hover:bg-background-50/15"
              }`}
            >
              {link.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => handleJump("contact")}
            className="hidden md:flex items-center gap-2 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-mail-send-line"></i>
            订阅吃瓜
          </button>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
              scrolled ? "text-foreground-950 hover:bg-background-100" : "text-background-50 hover:bg-background-50/15"
            }`}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-background-50 border-b border-background-200 px-4 py-3">
          <div className="grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <button
                key={link.id}
                type="button"
                onClick={() => handleJump(link.id)}
                className={`px-3 py-2.5 rounded-md text-sm text-left whitespace-nowrap transition-colors cursor-pointer ${
                  active === link.id
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {link.label}
              </button>
            ))}
          </div>
          <button
            type="button"
            onClick={() => handleJump("contact")}
            className="mt-2 w-full flex items-center justify-center gap-2 px-4 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-send-line"></i>
            订阅吃瓜
          </button>
        </div>
      )}
    </header>
  );
}